var _style, _path, _path2, _path3, _circle;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: -515.4908,
    cy: -532.942,
    r: 93.8734,
    gradientTransform: "matrix(0.6435 -0.7654 -0.5056 -0.4251 76.0793 -545.5815)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.073,
    style: {
      stopColor: "#EACC7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    style: {
      stopColor: "#ECAA59"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.307,
    style: {
      stopColor: "#EF802E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.358,
    style: {
      stopColor: "#EF6D3A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    style: {
      stopColor: "#F04B50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.516,
    style: {
      stopColor: "#F03E58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.689,
    style: {
      stopColor: "#DB359E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    style: {
      stopColor: "#CE37A4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    style: {
      stopColor: "#AC3CB4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.877,
    style: {
      stopColor: "#7544CF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    style: {
      stopColor: "#2B4FF2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.5,63h-35C7.1,63,1,56.9,1,49.5v-35C1,7.1,7.1,1,14.5,1h35C56.9,1,63,7.1,63,14.5v35 C63,56.9,56.9,63,49.5,63z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,13.1c6.2,0,6.9,0,9.3,0.1c2.3,0.1,3.5,0.5,4.3,0.8c1.1,0.4,1.9,0.9,2.7,1.8c0.8,0.8,1.3,1.6,1.8,2.7 c0.3,0.8,0.7,2,0.8,4.3c0,2.3,0,3,0,9.2s0,6.9-0.1,9.3c-0.1,2.3-0.5,3.5-0.8,4.3c-0.4,1.1-0.9,1.9-1.8,2.7c-0.8,0.8-1.6,1.3-2.7,1.8 c-0.8,0.3-2,0.7-4.3,0.8c-2.3,0-3,0-9.2,0s-6.9,0-9.3-0.1c-2.3-0.1-3.5-0.5-4.3-0.8c-1.1-0.4-1.9-0.9-2.7-1.8 c-0.8-0.8-1.3-1.6-1.8-2.7c-0.3-0.8-0.7-2-0.8-4.3c0-2.3,0-3,0-9.2s0-6.9,0.1-9.3c0.1-2.3,0.5-3.5,0.8-4.3c0.4-1.1,0.9-1.9,1.8-2.7 c0.8-0.8,1.6-1.3,2.7-1.8c0.8-0.3,2-0.7,4.3-0.8C25.1,13.1,25.8,13.1,32,13.1 M32,9.1c-6.2,0-7,0-9.4,0.1s-4,0.5-5.5,1.1 c-1.5,0.5-2.8,1.3-4,2.7s-2,2.6-2.7,4c-0.5,1.5-0.9,3.1-1.1,5.5C9.1,25,9.1,25.8,9.1,32s0,7,0.1,9.4s0.5,4,1.1,5.5 c0.5,1.5,1.3,2.8,2.7,4c1.2,1.2,2.6,2,4,2.7c1.5,0.5,3.1,0.9,5.5,1.1s3.2,0.1,9.4,0.1s7,0,9.4-0.1s4-0.5,5.5-1.1 c1.5-0.5,2.8-1.3,4-2.7c1.2-1.2,2-2.6,2.7-4c0.5-1.5,0.9-3.1,1.1-5.5s0.1-3.2,0.1-9.4s0-7-0.1-9.4s-0.5-4-1.1-5.5 c-0.5-1.5-1.3-2.8-2.7-4c-1.3-1.2-2.6-2-4-2.7c-1.5-0.5-3.1-0.9-5.5-1.1C39,9.1,38.2,9.1,32,9.1L32,9.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,19.9c-6.7,0-12.1,5.4-12.1,12.1S25.3,44.1,32,44.1S44.1,38.7,44.1,32S38.7,19.9,32,19.9z M32,40.1 c-4.4,0-8.1-3.6-8.1-8.1s3.6-8.1,8.1-8.1s8.1,3.6,8.1,8.1S36.4,40.1,32,40.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 44.1,
    cy: 19.9,
    r: 2.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.cd7cd43fe834c72c7f019814f104e313.svg";
export { ForwardRef as ReactComponent };